import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'modules/api/utils';
import { UrlNames } from 'modules/app/constants';
import { configService } from 'modules/app/services';

import type { MagicLinkParams } from './types';

const API_VERSION = 'v1';

const getBaseURL = () => `${configService.getUrl(UrlNames.AuthApi)}/${API_VERSION}`;

export const authenticationApi = createApi({
  reducerPath: 'authenticationApi',
  baseQuery: axiosBaseQuery({ baseURL: getBaseURL }),
  endpoints: (builder) => ({
    requestMagicLink: builder.mutation<void, MagicLinkParams>({
      query: (data) => ({
        url: '/auth/magic-link',
        method: 'POST',
        data,
      }),
    }),
  }),
});

export const { useRequestMagicLinkMutation } = authenticationApi;
